// Inserting a placeholder chip into the Email body, which is a RichTextEditor: either a Quill
// visual editor or, in "HTML Source" mode, a plain <textarea>.
//
// `container` wraps the editor; `setHtml` stores a new body (used for the textarea and the
// fallback); `findQuill` returns the Quill instance for an element (Quill.find in the app);
// `html` is the current body, for the fallback when neither editor is in the DOM.
export function insertIntoRichText(container, text, setHtml, findQuill, html = "") {
  const textarea = container?.querySelector("textarea");
  if (textarea) {
    const value = textarea.value;
    const start = textarea.selectionStart ?? value.length;
    const end = textarea.selectionEnd ?? start;
    setHtml(value.slice(0, start) + text + value.slice(end));
    return;
  }
  const editorEl = container?.querySelector(".ql-container");
  const quill = editorEl ? findQuill(editorEl) : null;
  if (quill && typeof quill.insertText === "function") {
    // getSelection(true) focuses the editor and returns where its cursor last was (clicking the
    // chip took focus away); with no cursor yet, insert before Quill's closing newline.
    const range = quill.getSelection(true);
    const index = range ? range.index : Math.max(0, quill.getLength() - 1);
    quill.insertText(index, text, "user");
    quill.setSelection(index + text.length, 0, "user");
    return;
  }
  setHtml(html + text);
}
